import React from 'react';
import * as styles from './styles.css';
import { IGalleryCell } from '../../../../../../types/newbuildingsCompare';
import { Image, Label, Responsive } from '@cian/ui-kit';
import { IconMediaPhoto16 } from '@cian/ui-kit-design-tokens/icons';

export interface IGalleryCellProps {
  cell: IGalleryCell;
  onOpen(): void;
}

export const GalleryCell = ({ cell, onOpen }: IGalleryCellProps): React.JSX.Element => {
  const src = cell.data?.images?.[0]?.thumbnailUrl ?? '';

  return (
    <div className={styles['container']} data-testid="GalleryCell" onClick={onOpen}>
      <Responsive desktop>
        <Image src={src} borderRadius="16px" display="block" height={200} />
      </Responsive>
      <Responsive phone tablet>
        <Image src={src} borderRadius="16px" display="block" height={128} />
      </Responsive>
      {src && cell.data?.countText && (
        <div className={styles['count-container']}>
          <Label
            color="accent-main-primary"
            icon={<IconMediaPhoto16 color="accent-main-primary" />}
            background="accent-main-secondary"
          >
            {cell.data?.countText}
          </Label>
        </div>
      )}
    </div>
  );
};
